// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Contact.css */
.contact-wrapper {
  background: url("https://images.unsplash.com/photo-1573497491208-6b1acb260507?auto=format&fit=crop&w=1600&q=80")
    no-repeat center center/cover;
  min-height: 100vh;
  padding: 2rem;
  font-family: "IBM Plex Sans", sans-serif;
}

.contact-header {
  text-align: center;
  margin-bottom: 2rem;
}

.ace-logo {
  width: 200px;
  margin-bottom: 1rem;
}

.contact-title {
  font-size: 2rem;
  font-weight: bold;
  color: white;
  text-shadow: 1px 1px 4px black;
}

.form-wrapper {
  width: 100%;
  max-width: 1000px;
  margin: 0 auto;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  border-radius: 12px;
  overflow: hidden;
}

iframe {
  width: 100%;
  border: none;
  min-height: 2000px;
}

/* Responsive */
@media (max-width: 768px) {
  .contact-title {
    font-size: 1.5rem;
  }

  .ace-logo {
    width: 150px;
  }

  .form-wrapper {
    margin: 0 1rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Contact/Contact.css"],"names":[],"mappings":"AAAA,gBAAgB;AAChB;EACE;iCAC+B;EAC/B,iBAAiB;EACjB,aAAa;EACb,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,yCAAyC;EACzC,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA,eAAe;AACf;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,cAAc;EAChB;AACF","sourcesContent":["/* Contact.css */\n.contact-wrapper {\n  background: url(\"https://images.unsplash.com/photo-1573497491208-6b1acb260507?auto=format&fit=crop&w=1600&q=80\")\n    no-repeat center center/cover;\n  min-height: 100vh;\n  padding: 2rem;\n  font-family: \"IBM Plex Sans\", sans-serif;\n}\n\n.contact-header {\n  text-align: center;\n  margin-bottom: 2rem;\n}\n\n.ace-logo {\n  width: 200px;\n  margin-bottom: 1rem;\n}\n\n.contact-title {\n  font-size: 2rem;\n  font-weight: bold;\n  color: white;\n  text-shadow: 1px 1px 4px black;\n}\n\n.form-wrapper {\n  width: 100%;\n  max-width: 1000px;\n  margin: 0 auto;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n  border-radius: 12px;\n  overflow: hidden;\n}\n\niframe {\n  width: 100%;\n  border: none;\n  min-height: 2000px;\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n  .contact-title {\n    font-size: 1.5rem;\n  }\n\n  .ace-logo {\n    width: 150px;\n  }\n\n  .form-wrapper {\n    margin: 0 1rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
